import type { ResolvedConfig } from '../types.js';

export function resolveAppUrl(config: ResolvedConfig, path: string): string {
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${config.appBaseUrl}${normalized}`;
}

export function appHomeUrl(config: ResolvedConfig): string {
  return `${config.appBaseUrl}/`;
}

export function errorRedirectUrl(config: ResolvedConfig, code: string): string {
  return resolveAppUrl(config, `${config.onErrorRedirect}${code}`);
}
